export const useStickOnScroll = () => {
  const stickyActive = useState(() => ref(false))
  return { stickyActive }
}
